<template>
  <div class="lad-tags">
    <el-button
      v-for="tag in value"
      :key="tag"
      size="mini"
      :type="type"
      :class="selectClass(tag)"
      @click="toggleSelect(tag)"
      >{{ tag }}</el-button
    >
  </div>
</template>

<script>
import Common from './Common'

export default {
  name: 'LadTagsMultiselect',
  extends: Common,
  data() {
    return {
      selected: [],
    }
  },
  methods: {
    toggleSelect(tag) {
      if (this.isSelected(tag)) {
        this.selected.splice(this.selected.indexOf(tag), 1)
      } else {
        this.selected.push(tag)
      }

      this.LadNextTick(() => this.handleUpdate(), 'LadTagsMultiselect')
    },
    isSelected(tag) {
      return this.selected.includes(tag)
    },
    selectClass(tag) {
      return this.isSelected(tag) ? 'is-selected' : 'is-unselected'
    },
    handleUpdate() {
      this.$emit('change', this.selected)
    },
  },
}
</script>

<style lang="scss">
.lad-tags {
  .el-button.is-unselected:not(:hover) {
    color: #c0c4cc;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
}
</style>
